import { render, staticRenderFns } from "./GoToTop.vue?vue&type=template&id=f9a84fb6&scoped=true"
import script from "./GoToTop.vue?vue&type=script&lang=js"
export * from "./GoToTop.vue?vue&type=script&lang=js"
import style0 from "./GoToTop.vue?vue&type=style&index=0&id=f9a84fb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a84fb6",
  null
  
)

export default component.exports